import { render, staticRenderFns } from "./ClinicalAddTrials.vue?vue&type=template&id=1332d479"
import script from "./ClinicalAddTrials.vue?vue&type=script&lang=js"
export * from "./ClinicalAddTrials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports